export default "__VITE_ASSET__Ckwsu2Hb__"